
<div class="desktop-width-limiter page-padding subscription-page">
    @if (loading && !error) {
        <div class="loading">
            <mat-progress-spinner class="loading-spinner" [diameter]="250" mode="indeterminate" color="primary">
            </mat-progress-spinner>
            <div class="loading-text"><h1>{{ 'general.loading' | translate }}...</h1></div>
        </div>
    }
    @else if (!loading && error) {
        <div class="errorContainer">
            <h1>{{ 'subscription.loading_error' | translate }}</h1>
        </div>
    } 
    @else {
        <div class="header row g-2">
            <div class="col-12 col-lg-8 col-xl-8 col-xxl-8 col-xxxl-8">
                <mat-card class="widget current-subscription">
                    <h1>{{ 'subscription.your_sub' | translate }}</h1>
                    <div class="sub-content">
                        <div class="sub-type-and-duration">
                            <img [src]="activeSubscription?.subscription?.image" alt="subscription-image"/>
                            @if(activeSubscription?.endDate) {
                                <p>{{ 'subscription.valid_until' | translate }} {{ activeSubscription.endDate | date: 'dd/MM/yyyy' }}</p>
                            }
                        </div>

                        <div class="features">
                            <h2>{{ 'subscription.features_title' | translate }}</h2>
                            <div class="features-text">
                                @for (feature of activeSubscription?.subscription?.features; track $index) {
                                    <div class="feature col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6">
                                        <div class="icon">
                                            <mat-icon>checkmark</mat-icon>
                                        </div>
                                        <p>{{ feature }}</p>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </mat-card>
            </div>

            <div class="col-12 col-lg-4 col-xl-4 col-xxl-4 col-xxxl-4">
                <mat-card class="widget info">
                    <h1>{{ 'subscription.info_title' | translate }}</h1>
                    <p class="description">
                        {{ 'subscription.info_description' | translate }}
                    </p>

                    <div class="upgrade-button-wrapper">
                        <button 
                            class="contact-button"
                            color="primary"
                            mat-flat-button 
                            (click)="openSubscriptionUpgradeContact()"
                        >
                            {{ 'subscription.contact' | translate | uppercase }}
                        </button>
                    </div>
                </mat-card>
            </div>
        </div>
        
        <div class="subscriptions row g-2">
            @for (subscription of subscriptions; track $index) {
                <subscription-card 
                    class="col-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4 col-xxxl-2" 
                    [subscription]="subscription"
                    [activeSubscriptionId]="activeSubscription.subscriptionId"
                    [activeSubscriptionExpiryDate]="activeSubscription.endDate"
                    [isUnderAge]="isUnderAge"
                />
            }
        </div>
    }
</div>